import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import classNames from 'classnames';
import isClient from 'commons/isClient';
import { EMAIL_REGEX } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { GET_CUSTOMER_IS_EXISTS } from '../queries';
const PreLogin = t0 => {
  const $ = _c(39);
  const {
    state: t1,
    actions,
    showGuestLogin,
    onGuestLoginClick
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      email: ""
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const state = t2;
  const [fromURL, setFromURL] = useState("");
  const inputRef = useRef(null);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const location = useLocation();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fetchPolicy: "no-cache"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [getCustomerIsExists, t4] = useLazyQuery(GET_CUSTOMER_IS_EXISTS, t3);
  const {
    loading: customerExistsLoading,
    data: customerIsExists
  } = t4;
  let t5;
  let t6;
  if ($[3] !== location.search) {
    t5 = () => {
      if (isClient() && location.search) {
        const params = new URLSearchParams(location.search);
        if (params.get("from")) {
          setFromURL(params.get("from"));
        }
      }
    };
    t6 = [location.search];
    $[3] = location.search;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[6] !== actions || $[7] !== customerIsExists) {
    t7 = () => {
      if (customerIsExists && customerIsExists.getCustomerIsExists) {
        if (customerIsExists.getCustomerIsExists.errors) {
          setIsEmailValid(false);
          if (inputRef && inputRef.current) {
            inputRef.current.focus();
          }
        } else {
          setIsEmailValid(true);
          actions.onCustomerExistsUpdate(customerIsExists.getCustomerIsExists.exists);
        }
      }
    };
    t8 = [customerIsExists, actions];
    $[6] = actions;
    $[7] = customerIsExists;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  useEffect(t7, t8);
  let t9;
  if ($[10] !== getCustomerIsExists || $[11] !== state.email) {
    t9 = async evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const isUpdatedEmailValid = EMAIL_REGEX.test(String(state.email.trim()).toLowerCase());
      if (!isUpdatedEmailValid) {
        setIsEmailValid(false);
        return false;
      }
      await getCustomerIsExists({
        variables: {
          email: state.email.trim()
        }
      });
      return false;
    };
    $[10] = getCustomerIsExists;
    $[11] = state.email;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const onSubmit = t9;
  let t10;
  if ($[13] !== fromURL) {
    t10 = fromURL && fromURL.length > 0 && <div className="return-link"><a href={fromURL}>← Return</a></div>;
    $[13] = fromURL;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h2 className="text-xl font-bold text-gray m-0">Log in or create account</h2>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== state.email) {
    t12 = state.email.trim();
    $[16] = state.email;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== actions) {
    t13 = evt_0 => {
      setIsEmailValid(true);
      actions.onEmailChange(evt_0);
    };
    $[18] = actions;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = evt_1 => {
      const emailValid = EMAIL_REGEX.test(String(evt_1.target.value.trim()).toLowerCase());
      setIsEmailValid(emailValid);
    };
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = !isEmailValid ? "Please enter a valid email address" : null;
  let t16;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t15) {
    t16 = <LabeledTextInput name="email" value={t12} label="Email address" autoComplete="username" onChange={t13} onBlur={t14} errorMessage={t15} ref={inputRef} />;
    $[21] = t12;
    $[22] = t13;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const t17 = customerExistsLoading || !isEmailValid;
  let t18;
  if ($[25] !== customerExistsLoading || $[26] !== t17) {
    t18 = <CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={t17} block={true} isLoading={customerExistsLoading}>Continue</CtaButton>;
    $[25] = customerExistsLoading;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== onSubmit || $[29] !== t16 || $[30] !== t18) {
    t19 = <form method="POST" onSubmit={onSubmit}>{t16}{t18}</form>;
    $[28] = onSubmit;
    $[29] = t16;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== onGuestLoginClick || $[33] !== showGuestLogin) {
    t20 = !!showGuestLogin && <><div className={classNames("[background:none] h-3.5 relative text-center mt-[.825rem] mb-0", "[&_hr]:border-0 [&_hr]:![border-top:1px_solid_#f1f1f1] [&_hr]:mt-[-13px] [&_hr]:mx-auto [&_hr]:mb-2.5 [&_hr]:w-full")}><span className="text-xs inline-block relative -top-1.5 text-gray bg-gray-light9">or</span><hr aria-hidden="true" /></div><div className="text-center"><CtaButton size="sm" styling="link" color="brand" hasArrow={true} onClick={onGuestLoginClick}>Don't want an account? Continue as guest</CtaButton></div></>;
    $[32] = onGuestLoginClick;
    $[33] = showGuestLogin;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t10 || $[36] !== t19 || $[37] !== t20) {
    t21 = <div className="text-gray"><div>{t10}{t11}{t19}{t20}</div></div>;
    $[35] = t10;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
};
PreLogin.propTypes = {
  state: PropTypes.shape({
    email: PropTypes.string
  }),
  actions: PropTypes.shape({
    onFBCallback: PropTypes.func,
    onEmailChange: PropTypes.func,
    onCustomerExistsUpdate: PropTypes.func
  }),
  showGuestLogin: PropTypes.bool,
  onGuestLoginClick: PropTypes.func
};
export default PreLogin;